import { __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CategorizeBox from "@/components/categorizeBox/index.vue";
import FormPage from "./addEditCopy/index.vue";

var GPSRInfoCreatePage = function (_super) {
  __extends(GPSRInfoCreatePage, _super);

  function GPSRInfoCreatePage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GPSRInfoCreatePage.prototype.created = function () {};

  GPSRInfoCreatePage = __decorate([Component({
    components: {
      CategorizeBox: CategorizeBox,
      FormPage: FormPage
    }
  })], GPSRInfoCreatePage);
  return GPSRInfoCreatePage;
}(Vue);

export default GPSRInfoCreatePage;